import React from 'react';

const StockDashboardStock = (props) => {
    return (
        <div>Dashboard Stock</div>
    )
}

export default StockDashboardStock